import { createFileRoute } from "@tanstack/react-router";

import { ChatLayout } from "src/pages/ChatLayout";

export const Route = createFileRoute("/_auth/chat")({
  component: RoutePage,
  ssr: true,
  staticData: {
    getBreadcrumb() {
      return {
        label: "Chat",
        href: "/chat",
      };
    },
  },
});

function RoutePage() {
  return <ChatLayout />;
}
